/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Attach_AddInputs */

const vi_grower_attach_add = /** @type {(inputs: Grower_Attach_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm tệp`)
};

/**

* @param {Grower_Attach_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_attach_add = /** @type {((inputs?: Grower_Attach_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Attach_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_attach_add(inputs)
});